import React, { Component } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../../data-service";
import { validateEmail, emptyCheck } from "../../../utilities";
import Spinner from "../../User/Common/Spinner/Spinner";

class ForgotPasswordContainer extends Component {
  state = {
    error: false,
    errorMessage: "",
    success: false,
    successMessage: "",
    showSpinner: false
  };
  focusElement(name) {
    this.refs[name].focus();
  }

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }

  validate(email) {
    if (emptyCheck(email)) {
      this.setState({ error: true, errorMessage: "Please enter your email" });
      this.focusElement("inputSignupEmail");
      return false;
    } else if (!validateEmail(email)) {
      this.setState({ error: true, errorMessage: "Please enter a valid email address" });
      this.focusElement("inputSignupEmail");
      return false;
    } else {
      this.setState({ error: false, errorMessage: "" });
      return true;
    }
  }
  forgotPasswordClicked() {
    const email = this.refs["inputSignupEmail"].value;
    if (this.validate(email)) {
      this.showSpinner(true);
      forgotPassword(email)
        .then(response => {
          this.showSpinner(false);
          this.setState({
            success: true,
            successMessage: `Email is sent to ${email} with instructions to reset password.`
          });
        })
        .catch(error => {
          this.showSpinner(false);
          if (error.request.response === "") {
            this.setState({
              error: true,
              errorMessage:
                "Request was made but no response received. Please try after sometime or contact administrator"
            });
            return;
          }
          if (error.response.data.ModelState) {
            this.setState({ error: true, errorMessage: "Could not reset password. Please contact administrator." });
          } else if (error.response.data) {
            this.setState({ error: true, errorMessage: error.response.data.Message });
          }
        });
    }
  }

  render() {
    let errorPlaceholder = null;
    if (this.state.error) {
      errorPlaceholder = <p className="alert alert-danger text-center">{this.state.errorMessage}</p>;
    }
    if (this.state.success) {
      errorPlaceholder = <p className="alert alert-success text-center">{this.state.successMessage}</p>;
    }
    return (
      <div className="card card-container" id="signupbox">
        <Spinner showSpinner={this.state.showSpinner} />
        {errorPlaceholder}
        <form className="form-signin">
          <input type="email" ref="inputSignupEmail" className="form-control mb-10" placeholder="Email" />
          <button
            className="btn btn-lg btn-primary btn-block btn-signin"
            type="button"
            onClick={() => this.forgotPasswordClicked()}
          >
            Reset Password
          </button>
          <Link to="/login">Sign In</Link>
        </form>
      </div>
    );
  }
}

export default ForgotPasswordContainer;



// WEBPACK FOOTER //
// ./src/containers/Login/ForgotPasswordContainer/ForgotPasswordContainer.js